import { Required } from '@hvlng/framework-bff/core';
import { HvlDateConverter } from '@hvlng/framework-bff/util';
import { JsonObject, JsonProperty } from 'json2typescript';
import { CodeTextModel } from '../../code-text/model/code-text-model';

@JsonObject('KovanHrTimeConstrainedCodeTextModel')
export class TimeConstrainedCodeTextModel extends CodeTextModel {
    @Required()
    @JsonProperty('beginDate', HvlDateConverter, true)
    beginDate: Date = null;

    @Required()
    @JsonProperty('endDate', HvlDateConverter, true)
    endDate: Date = null;

    @Required()
    @JsonProperty('count', Number, true)
    count: number = null;
}
